import { MusicNote } from '@phosphor-icons/react';

export default function AppleMusicIcon() {
  return <MusicNote size={20} aria-hidden="true" />;
}
